<template>
    <svg aria-hidden="true" focusable="false" width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.95652 3.97826C7.95652 5.89925 4.91304 10.5 4.47826 10.5C4.04348 10.5 1 5.89925 1 3.97826C1 2.05727 2.55727 0.5 4.47826 0.5C6.39925 0.5 7.95652 2.05727 7.95652 3.97826Z"
            stroke="black"
            stroke-width="0.5" />
        <circle cx="4.4782" cy="3.83331" r="2.02899" stroke="black" stroke-width="0.5" />
    </svg>
</template>
